/**
 * @Author:      lvs
 * @DateTime:    2018-4-20 19:28:40
 * @Description: ugc稿件管理
 */
"use strict";
angular.module("loginPageMangementModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("backstage.loginPageMgr", {
        url: "/loginPageMgr",
        views: {
            "":{
                template:'<div class="loginPageMgr" ui-veiw="main"></div>',
            }
        }
    }).state("backstage.loginPageMgr.loginMgr", {
        url: "/loginMgr",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/loginPageMangement/loginPageMangement_tpl.html',
                controller:'loginMangementCtrl'
            }
        }
    }).state("backstage.loginPageMgr.setSubdomains", {
        url: "/setSubdomains",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/loginPageMangement/setSubdomainsMgr/setSubdomainsMgr_tpl.html',
                controller:'setSubdomainsMgrCtrl'
            }
        }
    }).state("backstage.loginPageMgr.setSuccess",{
    	url:"/setSuccess?domainname",
    	views:{
    		"main@backstage":{
                templateUrl:'./main/backstage/loginPageMangement/setSubdomainsMgr/setSuccess.html',
                controller:'setSuccessCtrl'
            }
    	}
    }).state("backstage.loginPageMgr.smsMgr",{
    	url:"/smsMgr",
    	views:{
    		"main@backstage":{
                templateUrl:'./main/backstage/loginPageMangement/smsManage/smsManage_tpl.html',
                controller:'smsMgrCtrl'
            }
    	}
    });
}]);